function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref93c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref93c"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $355fdf839ac43079$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"9vqfN":"index.c880b077.js","7IPPd":"logo.c5f81c00.png","2HW2q":"home.25c1b5de.svg","dl46C":"news.268274a5.svg","825Dj":"attending.ec7ff07a.svg","gSttz":"faq.8f30cd3e.svg","gcGnI":"x.4678f3f6.png","eGTKj":"telegram.9c31b0e8.png","3vd9Q":"bluesky.a33e98fd.png","5OkXc":"file.125d04a6.svg","d9fUN":"con-not-found.25ecb727.jpg","13aJ4":"fursuit-photo.fe668bcb.jpg","iZdZB":"news.0bdbd927.jpg","j94aI":"events.ee858efb.avif","hwI9Y":"events.1c87d72b.webp","dMYZx":"events.7720ca96.jpg","b2yM2":"info.a6b04845.svg","3xfoU":"schedule.44018900.json","988A5":"hotel-outside.b856df94.jpg","2vFEc":"car.4798fcac.svg","37n6S":"train.7919db54.svg","2jbZ3":"bus.f6b37c93.svg","ctCJQ":"plane.29606eef.svg","gZ6v0":"egg.78a97c00.svg","EUGPo":"registration.b26901d6.jpg","krtqP":"reg-options.9c830ef2.svg","lH8A4":"hotel.6b227f4e.svg","9ltCe":"prices.b5c19531.svg","17u6c":"hotel-sign.b5d08307.jpg","1yPeS":"gym.6c116b13.svg","iFTAj":"exec.ffb4d283.svg","il9Xn":"breakfast.c7d998b2.svg","jm982":"food.c707744f.svg","d3LWO":"clock.1e741a8a.svg","9jCkj":"pets.b2394cce.svg","8dkLa":"map.14f2d1b1.jpg","2vnBA":"fluffs.2fff2177.jpg","6KF1L":"charity.20837831.jpg","fzFjk":"charity-2.b2074e4d.jpg","79qbr":"charity-3.538932ff.jpg","eouk1":"index.a3651ebc.css"}'));


//# sourceMappingURL=index.23ec965b.js.map
